module.exports = __webpack_public_path__ + "img/support_equi_mb_1.cad8fe33.jpg";